import { displayDateFormat } from 'core/styles/variables';
import i18next from 'i18next';
import { DateTime } from 'luxon';

const convertLanguageCodeToLanguage = (languageCode: string): string | undefined => {
  if (!languageCode) {
    return undefined;
  }
  const language = new Intl.DisplayNames([i18next.language ?? 'en'], { type: 'language' });
  return language.of(languageCode);
};

const convertCountryCodeToCountryName = (countryCode: string): string => {
  const countryNames = new Intl.DisplayNames([i18next.language ?? 'en'], { type: 'region' }).of(countryCode.toUpperCase()) ?? '';
  return countryNames;
};

const getRegisteredAtDate = (registeredAt: string): string => {
  const date = DateTime.fromISO(registeredAt).toFormat(displayDateFormat);
  return date;
};

export { convertLanguageCodeToLanguage, convertCountryCodeToCountryName, getRegisteredAtDate };
